import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TheatreCancelDialogType } from '@stockcare-models/TheatreCancelDialogType';

@Component({
  standalone: false,
  templateUrl:
    './theatre-care-operating-room-cancel-changes-dialog.component.html',
  styleUrls: [
    './theatre-care-operating-room-cancel-changes-dialog.component.scss',
  ],
})
export class TheatreCareOperatingRoomCancelChangesDialogComponent
  implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<
      TheatreCareOperatingRoomCancelChangesDialogComponent
    >
  ) {}

  ngOnInit() {}

  save() {
    this.dialogRef.close(TheatreCancelDialogType.Save);
  }

  stay() {
    this.dialogRef.close(TheatreCancelDialogType.Stay);
  }
}
